export default __webpack_public_path__ + "static/media/Square.2508110d.png";